import { MDBBtn, MDBCol } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { formatCnpj } from "../../utils";
import { Pager } from "../utils/Pager";
import moment from "moment";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { Alert } from "@blueprintjs/core";

@observer
export class Relatorios extends React.Component<{}, {}> {

  obs = observable({
    date_periodo_relatorio: [] as any,
    selectEmpresa: newEmpresa() as IEmpresa,
    erros_relatorio: [] as any,
    relatorios: [] as any,
    open_erros_relatorio : false
  })

  constructor(props: any) {
    super(props);
  }

  async handleChangePage(page: number) {

    ResultadoStore.obs.page_tasks_relatorio = page

    await ResultadoStore.handleTasksPaged(ResultadoStore.obs.page_tasks_relatorio)

  }

  handleErrosRelatorio(error: string) {
          let list_erros = error.split(",")
          this.obs.erros_relatorio = list_erros?.map(x => {
              return { "erros": x }
          })
          this.obs.open_erros_relatorio = true
      }

  onCloseErros() {
          this.obs.open_erros_relatorio = false
          this.obs.erros_relatorio = []
      }

  async handleAtualizar() {
    ResultadoStore.obs.page_tasks_relatorio = 1
    ResultadoStore.obs.length_tasks_relatorio = 0

    await ResultadoStore.handleTasksPaged(1)  
  }

  render() {

    let items = ResultadoStore.obs.tasks_relatorio?.map(imp => {

      return ({
        id: imp._id,
        cnpj: imp.cnpj,
        razao_social: imp.razao_social,
        inserted_at: imp.inserted_at,
        date_start: imp.date_start,
        date_end: imp.date_end,
        status: imp.status,
        relatorio_id: imp.relatorio_id,
        error: imp.error,
        modelo: imp.modelo,
        tipo: imp.tipo,
        tipo_exportacao: imp.tipo_exportacao
      });

    });

    function statusFormatter(cell, row) {

      return getTag(row.status, "relatorio");

    }

    function exportFormatter(cell, row) {

      switch(cell){

        case "export": return "EXPORTAÇÃO"
        case "avisos": return "AVISOS"
        case "email": return "E-MAIL"
        case "export_filtros": return "EXPORTAÇÃO FILTROS"
        default: return ""

      }

    }

    const errosFormatter = (cell, row) => {
                return (
                    <>
                        <MDBBtn
                            color="default"
                            rounded
                            size="sm"
                            disabled={row.status != 3}
                            onClick={() => this.handleErrosRelatorio(row.error)}
                        >
                            <img src="/images/view.png" />
                        </MDBBtn>
                    </>
                );
            }



    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => ResultadoStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const cnpjFormatter = (cell, row) => {
      return formatCnpj(row.cnpj)
    };

    const periodoFormatter = (cell, row) => {
      return moment(row.date_start).add(3, "hour").format("DD/MM/YYYY") + " - " + moment(row.date_end).add(3, "hour").format("DD/MM/YYYY");
    };

    return (
      <>
        <MDBCol md="2">
          <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleAtualizar()}
          >
              Atualizar
          </MDBBtn>
      </MDBCol>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={items}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="15%">Criado em</TableHeaderColumn>
            <TableHeaderColumn dataFormat={periodoFormatter} width="15%">Período</TableHeaderColumn>
            <TableHeaderColumn dataField="modelo" width="10%">Modelo</TableHeaderColumn>
            <TableHeaderColumn dataField="tipo" width="10%">Tipo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={exportFormatter} dataField="tipo_exportacao" width="15%">Exportação</TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={ResultadoStore.obs.page_tasks_relatorio}
            totalCount={ResultadoStore.obs.length_tasks_relatorio}
            pageSize={15}
            onPageChange={page => this.handleChangePage(page)}
          />
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_erros_relatorio}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
      >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
              {this.obs.erros_relatorio.length &&
                  <div className="errosSped">
                      <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                          <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                          <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                      </BootstrapTable>
                  </div>
              }
          </MDBCol>
      </Alert>

        <LoadingModal open={ResultadoStore.obs.loading_download} onClose={() => ResultadoStore.obs.loading_download = false} title={"Baixando arquivo"} />
      </>
    )
  }
}

export default Relatorios;
